import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @ViewChild('exampleInput', { static: false }) exampleInput: ElementRef;
  arrayComponent: any;
  componentRender: any;
  MAX_CHARACTERS: number = 15;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'default',
        componentRender:
          `<form>
  <div class="form-group">
    <label for="input-simple-govco">Etiqueta del campo <b>*</b></label>
    <input type="text" class="form-control input-govco" placeholder="Ejemplo del texto a ingresar" id="input-simple-govco" required>
  </div>
</form>`,
        titulo: 'Input sencillo',
        subtitulo: 'Input básico, compuesto por una etiqueta y el campo del formulario de tipo texto.'
      },
      {
        id: 'contador',
        componentRender:
          `<form>
  <div class="form-group">
    <label for="input_con_contador">Etiqueta del campo <b>*</b></label>
    <input type="text" id="input_con_contador" class="form-control input-govco" required placeholder="Ejemplo del texto a ingresar" maxlength="${this.MAX_CHARACTERS}">
  </div>
</form>`,
        codejs: `
        const MAX_CHARACTERS = 15;
        utils.countCharacter("input_con_contador", MAX_CHARACTERS);
        `,
        titulo: 'Con contador',
        subtitulo: 'Este uso es de gran utilidad en aquellos casos que sea requerida la restricción del número de caracteres a ingresar por el usuario.'
      },
      {
        id: 'sin_etiqueta',
        componentRender:
          `<form>
  <div class="form-group">
    <input type="text" id="input_sin_etiqueta" class="form-control input-govco" title="Nombre o etiqueta del campo" aria-label="Nombre o etiqueta del campo" placeholder="Ejemplo del texto a ingresar" required maxlength="${this.MAX_CHARACTERS}">
  </div>
</form>`,
        titulo: 'Sin etiqueta label',
        subtitulo: 'Utilizar el atributo <code>title</code> o <code>aria-label</code> para identificar el campo cuando el elemento <code>label</code> no puede ser usado.'
      },
      {
        id: 'desactivado',
        componentRender: `<form>
  <div class="form-group">
    <label for="id-input-govco">Etiqueta del campo</label>
    <input class="form-control input-govco" id="id-input-govco" type="text" placeholder="Input desactivado..." disabled>
  </div>
</form>`,
        titulo: 'Desactivado',
        subtitulo: 'Este atributo indica que el control no está disponible para interacción. De igual forma, el valor de un control deshabilitado no es enviado con el formulario.'
      },
      {
        id: 'error',
        componentRender: `<form>
  <div class="form-group">
    <label for="errorInput">Etiqueta del campo</label>
    <input type="number" class="form-control input-govco is-invalid" id="errorInput" placeholder="Input error" aria-labelledby="invalid-feedback" required>
    <div id="invalid-feedback" class="invalid-feedback">
      Por favor digitar su número de identificación sin espacios ni caracteres especiales. Por ejemplo: 1004003849
    </div>
  </div>
</form>`,
        titulo: 'Error',
        subtitulo: 'Cuando se produzca un error de validación, es necesario proporcionar una descripción textual que indique el problema de manera comprensible, informe de los valores admitidos y proporcione un ejemplo. En el siguiente caso, se señala el error a través del color rojo y la descripción del problema se encuentra debajo del campo. Sin embargo es necesario asociar el id del texto del error al campo del formulario haciendo uso del atributo aria-labelledby, permitiendo a los usuarios que utilizan tecnología de asistencia como lectores de pantalla acceder a la descripción del mismo.'
      }, {
        id: 'valido',
        titulo: 'Válido',
        subtitulo: 'Aquellos campos que han sido diligenciados correctamente se distinguen visualmente a través del color verde y un mensaje de confirmación ubicado debajo del campo, el cual debe estar asociado a través del atributo aria-labelledby, permitiendo a usuarios con tecnología de asistencia acceder al mensaje de validación.',
        componentRender: `<form>
  <div class="form-group">
    <label for="inputValido">Etiqueta del campo</label>
    <input type="text" class="form-control input-govco is-valid" id="inputValido" aria-labelledby="valid-feedback" placeholder="Input valido" required>
    <div class="valid-feedback">
      Este es el mensaje correcto.
    </div>
  </div>
</form>`,
      },
    ]
    this.infoComponent = {
      titulo: "Campos de texto - <input>",
      descripcion: "Son creados para el ingreso de texto de los usuarios dentro de un elemento <form> y su valor varía dependiendo del atributo type. En esta sección se especifica los elementos <input> de tipo text, number, email y password. Los campos de texto podrán tener un contador de caracteres y dependiendo de la complejidad del campo tendrá una descripción de ejemplo con el própósito de guiar al usuario en la manera que debe ingresar los datos."
    }

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    window.utils.init();
    window.utils.countCharacter("input_con_contador", this.MAX_CHARACTERS);
  }

}